var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['circle', 'outer', _vm.outerClass]},[_c('v-layout',{class:['circle', 'inner'],attrs:{"align-center":"","justify-center":""}},[(_vm.partnerInitials)?_c('span',{staticClass:"inner-text"},[_vm._v(" "+_vm._s(_vm.partnerInitials)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }